import Constant from "@constant/index.js";

export default class OrderReduceWapView{
    constructor(model){
        this._model = model;
        this._parentEl = this._model._parent._view._headerBoxEl;
    }

    render(){
        let html = "";
        html += `<div class="clearfix good_item_head">`;
        if(this._model._parent._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            html +=   `<span class="item le_tag" style="margin-left:0.07rem;">${this._model._name}</span>`;
        }else{
            html +=  `<span class="item le_tag">${this._model._name}</span>`;
        }
        html += `<span class="item name">${this._model._desc}</span>

            </div>`;

        // if(this._model._parent._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
        //     $(this._parentEl).append($(html));
        // }else{
        //     $(this._parentEl).prepend($(html));
        // }
        $(this._parentEl).prepend($(html));
        
    }
}